var _style, _rect, _defs, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7, _path8, _path9, _path10, _path11, _rect5, _rect6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect7, _path49, _path50, _path51, _path52, _rect8, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _rect9, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpDocNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 254.3 182.5",
    style: {
      enableBackground: "new 0 0 254.3 182.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000183942425119782676670000004905232397552601514_);}\n\t.st2{fill:#1B3175;}\n\t.st3{fill:#D1D3D4;}\n\t.st4{fill:#68E1FD;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    x: 72.2,
    y: 0.8,
    className: "st0",
    width: 159.4,
    height: 154.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17446"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 254.3,
    height: 182.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081611763970954859260000017131484756324004001_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17445",
    style: {
      clipPath: "url(#SVGID_00000081611763970954859260000017131484756324004001_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18062",
    className: "st2",
    d: "M231.5,155.5H72.2V0.8h159.4L231.5,155.5L231.5,155.5z M231.5,0H72.2 c-0.4,0-0.8,0.3-0.8,0.8v154.7c0,0.4,0.3,0.8,0.8,0.8h159.4c0.4,0,0.8-0.3,0.8-0.8V0.8C232.3,0.3,232,0,231.5,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18063",
    className: "st3",
    d: "M118.4,20h36.3c0.5,0,0.9,0.4,0.9,0.9v0.9c0,0.5-0.4,0.9-0.9,0.9h-36.3 c-0.5,0-0.9-0.4-0.9-0.9v-0.9C117.5,20.4,117.9,20,118.4,20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3759",
    x: 118.7,
    y: 33.2,
    className: "st3",
    width: 14.3,
    height: 16.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18064",
    className: "st3",
    d: "M141.8,34.4H210c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-68.2 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,35.4,140.6,34.4,141.8,34.4L141.8,34.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18065",
    className: "st3",
    d: "M141.8,42.5h46.6c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-46.6 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,43.4,140.6,42.5,141.8,42.5L141.8,42.5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3760",
    x: 118.7,
    y: 100.2,
    className: "st3",
    width: 14.3,
    height: 16.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18066",
    className: "st3",
    d: "M141.8,101.4H210c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-68.2 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,102.3,140.6,101.4,141.8,101.4L141.8,101.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18067",
    className: "st3",
    d: "M141.8,109.4h46.6c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-46.6 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,110.4,140.6,109.4,141.8,109.4L141.8,109.4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    x: 118.7,
    y: 125.1,
    className: "st3",
    width: 14.3,
    height: 16.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18068",
    className: "st3",
    d: "M141.8,126.3H210c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-68.2 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,127.3,140.6,126.3,141.8,126.3L141.8,126.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18069",
    className: "st3",
    d: "M141.8,134.4h46.6c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-46.6 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C139.7,135.3,140.6,134.4,141.8,134.4L141.8,134.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18070",
    className: "st4",
    d: "M78.6,4.5c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7 S77.7,4.5,78.6,4.5L78.6,4.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18071",
    className: "st3",
    d: "M84.6,4.5c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7 S83.6,4.5,84.6,4.5L84.6,4.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18072",
    className: "st3",
    d: "M90.6,4.5c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S89.6,4.5,90.6,4.5 L90.6,4.5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    x: 105.6,
    y: 11.6,
    className: "st3",
    width: 0.9,
    height: 143.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3763",
    x: 72.2,
    y: 11.2,
    className: "st3",
    width: 159.4,
    height: 0.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18074",
    className: "st2",
    d: "M227.8,128.6c0.1-1.6-0.2-3.2-1-4.6c-0.7-0.9-1.4-1.9-2-2.9c-0.9-1.9-0.3-4-0.5-6.1 c-0.2-1.7-0.9-3.3-2.1-4.5c-1.1-1.1-2.4-1.8-3.4-2.9c-1.7-1.8-2.1-4.4-3.1-6.7c-1.3-3.2-3.7-6-6.7-7.8c1.8,3.6-2.3,8.3-0.5,11.9 c0.6,1.2,1.7,2,2.2,3.2c1.1,2.9-2.5,6.1-1.3,9c0.6,1.5,2.1,2.3,2.8,3.7c1,1.9,0.2,4.1,0.3,6.2c0.1,2.9,1.9,5.5,4,7.5 c1.3,1.2,2.8,2.3,4.2,3.5c1.7,1.3,2.4,2.8,3.9,0.6C226.6,135.7,227.7,132.2,227.8,128.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18075",
    className: "st2",
    d: "M229.7,130.2c-0.5-2.2-0.9-4.7,0-6.8c1-2.4,3.6-4.1,3.9-6.7c0.2-1.7-0.7-3.4-0.3-5.1 s1.7-2.8,2.8-4c2.6-2.9,4.1-6.5,4.4-10.3c1.7,2.1,3.1,4.4,4.2,6.9c0.9,2.6,0.9,5.5-0.6,7.8c-0.4,0.5-0.8,1.1-1.1,1.7 c-0.5,1.6,0.9,3.2,1.6,4.7c0.9,1.8,0.7,4-0.5,5.7c-1.5,1.8-4.3,2.6-5.1,4.8c-0.2,0.8-0.3,1.7-0.3,2.6c-0.3,3-2.4,5.6-5.4,6.4 c-1.8,0.4-1.7-0.3-2-1.7C230.9,134.1,230.2,132.2,229.7,130.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18076",
    className: "st2",
    d: "M224.1,114.1c-1.2-4.3-1.7-8.8-3-13.1c-1.1-3.3-2.5-6.6-4.1-9.8l5.3,2.3 c1.7,0.7,3.6,1.6,4.4,3.2c1.4,2.9-1.1,6.6,0.4,9.5c0.6,0.9,1.3,1.8,2.1,2.7c1.6,2.2,1.3,5.2,0.5,7.8c-0.4,1.1-2,6.8-3.4,5.2 c-0.6-0.6-0.6-3-0.9-3.9C224.9,116.8,224.5,115.5,224.1,114.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18077",
    className: "st2",
    d: "M227,171.3c-1.1-7-4.4-31.8-4.4-32.1l0.9-0.1c0,0.2,3.4,25,4.4,32.1L227,171.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18078",
    className: "st2",
    d: "M228.2,177.9h-0.9c0.1-8.4,3.5-40.3,5.5-42.5l0.6,0.6C232.2,137.5,228.3,166.5,228.2,177.9 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18079",
    className: "st2",
    d: "M230.1,176.4h-0.9c0.8-18-3-55.8-3.1-56.2l0.9-0.1C227,120.4,230.8,158.3,230.1,176.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18080",
    className: "st0",
    d: "M217.9,151.1h19.9l-1.4,22.6c-0.2,3.9-3.1,6.9-6.6,6.9h-3.9c-3.5,0-6.4-3-6.6-6.9 L217.9,151.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18081",
    className: "st2",
    d: "M229.7,181.1h-3.9c-3.7,0-6.8-3.2-7.1-7.4l-1.4-22.6c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1 h19.9c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.1,0.3l-1.4,22.6C236.5,177.9,233.4,181.1,229.7,181.1 M218.3,151.6l1.4,22.1 c0.2,3.7,2.9,6.5,6.2,6.5h3.9c3.2,0,6-2.9,6.2-6.5l1.4-22.1H218.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18082",
    className: "st0",
    d: "M61.4,166.5c-0.1,0.8,0.6,9.5,0.6,9.5s10.7,1.8,10.8,1.1c0.1-0.7,3.2-4,3.2-4l-4.3-2 l-0.4-10.6L61.4,166.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18083",
    className: "st2",
    d: "M71.9,177.7c-3.4-0.2-6.7-0.7-10-1.3c-0.2,0-0.3-0.2-0.3-0.4c-0.1-0.9-0.8-8.8-0.6-9.6 c0-0.1,0.1-0.2,0.2-0.3l10-5.9c0.1-0.1,0.3-0.1,0.4,0s0.2,0.2,0.2,0.3l0.4,10.3l4.1,1.9c0.1,0.1,0.2,0.2,0.2,0.3s0,0.2-0.1,0.3 c-1.2,1.1-2.2,2.4-3.1,3.7c0,0.1-0.1,0.2-0.2,0.3C72.7,177.7,72.3,177.7,71.9,177.7 M62.4,175.7c4.4,0.7,9.2,1.4,10.1,1.2 c0.8-1.3,1.8-2.5,2.9-3.6l-3.8-1.8c-0.1-0.1-0.2-0.2-0.2-0.3l-0.4-9.9l-9.2,5.5C61.8,167.8,62.1,172.5,62.4,175.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18084",
    className: "st0",
    d: "M28.9,167.3l-1.6,10.8h7.1l4.2-11.6L28.9,167.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18085",
    className: "st2",
    d: "M34.4,178.5h-7.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l1.6-10.8 c0-0.2,0.2-0.3,0.3-0.3l9.7-0.8c0.1,0,0.3,0,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.4l-4.2,11.6C34.8,178.4,34.6,178.5,34.4,178.5  M27.8,177.7h6.4l3.9-10.8l-8.8,0.7L27.8,177.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18086",
    className: "st0",
    d: "M52.6,20.4c-0.2,0-0.5,0-0.7,0c-1.1,0.2-2.3,0.6-3.3,1.1c-1.7-1.2-4.1-1-6-0.3 c-4.9,1.7-7.6,6-10,10.3c-1.1,2-2.7,4-3.5,6.1c-1.2,3.1-1.4,5.7-3.5,8.5c-2,2.7-4.6,4.9-6.8,7.4c-3,3.4-5.4,7.5-6,12 c-1.3,9.6,7.9,19.1,17.3,18.4s19.5-3.1,25.2-10.6c6.3-8.2,6.9-20.8,6-30.7c-0.5-5.2-0.4-10.8-2.6-15.6c-0.9-2.1-2-4-3.4-5.7 C54.5,20.8,53.6,20.4,52.6,20.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18087",
    className: "st2",
    d: "M29.2,84.5c-4.6-0.1-8.9-2.1-12-5.5c-3.5-3.5-5.2-8.4-4.7-13.4c0.6-4.1,2.6-8.2,6.1-12.3 c0.9-1,1.9-2,2.8-3c1.4-1.4,2.7-2.9,3.9-4.4c1.2-1.7,2-3.5,2.5-5.5c0.3-0.9,0.6-1.9,1-2.9c0.6-1.4,1.4-2.8,2.2-4 c0.5-0.7,0.9-1.4,1.3-2.1c2.4-4.3,5.2-8.7,10.2-10.5c1.4-0.5,4.1-1.1,6.2,0.2c1.1-0.5,2.1-0.8,3.3-1.1h0.8c1,0.1,2,0.5,2.8,1.2 c1.5,1.7,2.7,3.7,3.5,5.8c1.8,3.8,2.1,8.1,2.4,12.2c0.1,1.2,0.2,2.3,0.3,3.5c0.8,7.6,1,21.8-6,31C51,80,42.6,83.5,30.3,84.5 C29.8,84.4,29.5,84.5,29.2,84.5 M45.6,20.9c-1,0-2,0.2-3,0.6c-4.8,1.7-7.5,6-9.8,10.2c-0.4,0.7-0.9,1.4-1.3,2.1 c-0.8,1.2-1.6,2.5-2.2,3.9c-0.4,1-0.7,1.9-0.9,2.9c-0.5,2.1-1.4,4.1-2.6,5.8c-1.2,1.6-2.6,3.1-4,4.5c-0.9,1-1.9,2-2.8,3 c-3.4,3.9-5.4,7.9-5.9,11.8c-0.5,4.7,1.2,9.4,4.5,12.7c3.1,3.5,7.7,5.4,12.4,5.2c12.1-0.9,20.3-4.3,24.9-10.4 c6.9-9,6.6-22.9,5.9-30.4c-0.1-1.2-0.2-2.3-0.3-3.5c-0.3-4.1-0.6-8.2-2.3-12c-0.8-2-1.9-3.9-3.3-5.6c-0.7-0.6-1.5-0.9-2.4-1 h-0.7c-1,0.3-2,0.6-3,1c-0.1,0.1-0.4,0.2-0.5,0.1C47.6,21.2,46.6,20.9,45.6,20.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18088",
    className: "st0",
    d: "M66.6,86.7l-7.2-37.9l-20.8,1.7V83L66.6,86.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18089",
    className: "st2",
    d: "M66.6,87.1L66.6,87.1l-28-3.8c-0.2,0-0.3-0.2-0.3-0.4l-0.1-32.5c0-0.2,0.2-0.4,0.4-0.4 l20.8-1.7c0.2,0,0.4,0.1,0.4,0.3L67,86.5c0,0.1,0,0.2-0.1,0.3C66.8,87.1,66.7,87.1,66.6,87.1 M39,82.6l27.1,3.6l-7.1-37 l-20.1,1.6L39,82.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18090",
    className: "st2",
    d: "M38.6,83c0,0-8.7,61.7-11.3,84.8l11.2,1.8c0,0,7.6-32.2,14.9-53.1l6.9,53.1l12.5-1.6 l-3.9-85H38.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18091",
    className: "st4",
    d: "M21,68.2l12.7,3.7l-1.9,31.7l14.5-0.4l-2.9-50.8l11.8-0.5c0,0.5,3.8,41.8,5,51.6l14.1-4.3 L68.6,70l7.9-4.1c0,0-4.9-19.6-21.3-18.6c-15.1,0.9-9.8,0.9-9.5,0.9c-0.3,0-12,0.1-17.3,7.2C25.4,59.3,22.9,63.6,21,68.2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18092",
    className: "st0",
    d: "M53.6,45.2l1.4,7.4c0,0,0.1,4.3-4.7,3.9c-2.8-0.2-5.4-1.7-7-4.1c-0.5-3-1-6.1-1.5-9.1 c-0.6-3.4-1.5-6.9-1.7-10.3c3.6,1.1,7.9-3.3,9.1-6.3c0.6,1.8,0.1,3.8-1.1,5.3c2-0.7,3.6-2.3,4.2-4.4c1,0.8,2,1.7,2.9,2.6 c0.8,1.1,1.4,2.3,1.8,3.6c0.7,2.3,1.3,5.7,0.1,7.9C55.6,44.7,53.6,45.2,53.6,45.2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18093",
    className: "st2",
    d: "M50.8,56.9h-0.6c-3-0.2-5.7-1.8-7.3-4.3c0,0,0-0.1-0.1-0.1l-1.5-9.1 c-0.2-1.1-0.4-2.1-0.6-3.2c-0.5-2.3-0.9-4.7-1.1-7.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1c3.3,1.1,7.5-3.3,8.5-6 c0.1-0.2,0.3-0.3,0.5-0.2c0.1,0,0.2,0.1,0.2,0.2c0.5,1.5,0.3,3-0.4,4.4c1.3-0.8,2.2-2,2.7-3.5c0-0.1,0.2-0.3,0.3-0.3 c0.5-0.1,3.3,2.8,3.3,2.8c0.8,1.1,1.4,2.4,1.8,3.7c0.5,1.6,1.5,5.6,0.1,8.2c-0.7,1.5-1.9,2.7-3.4,3.5c0.3,1.4,1.3,7,1.3,7 c0,1.2-0.5,2.4-1.3,3.3C53.1,56.5,52,56.9,50.8,56.9 M43.7,52.2c1.5,2.2,4,3.6,6.7,3.8c1.1,0.2,2.3-0.1,3.2-0.9 c0.7-0.7,1.1-1.7,1.1-2.6c0,0-1.3-7.2-1.4-7.3c0-0.2,0.1-0.4,0.3-0.5c1.5-0.6,2.6-1.8,3.2-3.2c1.2-2.4,0.3-6.1-0.2-7.6 c-0.4-1.3-1-2.4-1.7-3.5c-0.2-0.2-1.7-1.7-2.4-2.3c-0.8,1.9-2.3,3.4-4.3,4.1c-0.2,0.1-0.4,0-0.5-0.2c-0.1-0.1-0.1-0.3,0-0.5 c0.9-1,1.4-2.4,1.3-3.8c-1.6,2.7-5.2,6.1-8.5,5.6c0.2,2.2,0.5,4.3,1,6.5c0.2,1.1,0.4,2.2,0.6,3.3L43.7,52.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18094",
    className: "st0",
    d: "M42.1,38c-0.2-0.5-0.6-1-1.1-1.2s-1-0.4-1.5-0.5c-0.3-0.1-0.6-0.1-0.9,0 c-0.2,0.1-0.4,0.2-0.5,0.3c-0.4,0.3-0.7,0.7-0.8,1.2c-0.1,0.4,0,0.8,0.1,1.1c0.1,0.4,0.3,0.8,0.5,1.2c1,1.5,2.9,1.9,4.4,1l0,0 l0,0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18095",
    className: "st2",
    d: "M40.6,41.9c-1.2,0-2.3-0.6-3-1.6c-0.2-0.4-0.4-0.8-0.5-1.2s-0.2-0.9-0.1-1.3 c0.1-0.5,0.5-1,0.9-1.4c0.2-0.2,0.4-0.3,0.6-0.4c0.3-0.1,0.7-0.1,1,0c0.6,0.1,1.1,0.3,1.6,0.5c0.6,0.3,1,0.8,1.2,1.4 c0.1,0.2,0,0.4-0.2,0.4l0,0c-0.2,0.1-0.4,0-0.4-0.2l0,0l0,0c-0.2-0.5-0.5-0.8-1-1.1c-0.4-0.2-0.9-0.4-1.4-0.4 c-0.2-0.1-0.5-0.1-0.7,0s-0.3,0.1-0.4,0.2c-0.3,0.2-0.6,0.6-0.7,0.9c0,0.3,0,0.7,0.1,1c0.1,0.4,0.3,0.7,0.5,1.1 c0.9,1.3,2.7,1.7,4,0.9c0.2-0.1,0.4-0.1,0.5,0.1c0.1,0.2,0.1,0.4-0.1,0.5C42,41.7,41.3,41.9,40.6,41.9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18096",
    className: "st2",
    d: "M54,48.1c0,0-2.9,1.4-5.2-0.2c-1.3-0.8-2.2-2.2-2.4-3.7c0,0,4.3,2.2,7.2,1.1L54,48.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18097",
    className: "st2",
    d: "M51.4,49.1c-1,0-2-0.3-2.8-0.9c-1.4-0.9-2.3-2.3-2.6-4c0-0.2,0.1-0.4,0.3-0.4 c0.1,0,0.1,0,0.2,0.1c0,0,4.2,2.1,6.9,1.1c0.1,0,0.2,0,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3l0.4,2.8c0,0.2-0.1,0.3-0.2,0.4 C53.3,48.9,52.4,49.1,51.4,49.1 M46.9,44.9C47.3,46,48,47,49,47.6c1.4,0.8,3.1,0.9,4.6,0.3l-0.3-2C51,46.5,48.2,45.5,46.9,44.9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18098",
    className: "st0",
    d: "M52.5,33.5c0,0,3.1,3.1,2.6,3.8S53,37.9,53,37.9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18099",
    className: "st2",
    d: "M53.3,38.3h-0.2c-0.2,0-0.4-0.2-0.4-0.4l0,0l0,0c0-0.2,0.2-0.4,0.4-0.4l0,0 c0.5,0,1.5-0.1,1.8-0.5c-0.6-1.3-1.5-2.4-2.6-3.3c-0.1-0.1-0.1-0.4,0-0.5s0.4-0.1,0.5,0c1.5,1.5,3.2,3.4,2.7,4.3 S53.8,38.3,53.3,38.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18100",
    className: "st2",
    d: "M48.3,33.7c0.3-0.1,0.7,0.1,0.9,0.5c0.2,0.3,0.1,0.8-0.2,1c-0.3,0.1-0.7-0.1-0.9-0.5 C47.9,34.4,48,33.9,48.3,33.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18101",
    className: "st2",
    d: "M54.8,32.5c0.3-0.1,0.7,0.1,0.9,0.5c0.2,0.3,0.1,0.8-0.2,1c-0.3,0.1-0.7-0.1-0.9-0.5 C54.4,33.2,54.5,32.7,54.8,32.5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18102",
    className: "st0",
    d: "M56.3,39.1c0,0-1.5,3.6-5.8,1.3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18103",
    className: "st2",
    d: "M53.1,41.5c-1,0-2-0.3-2.8-0.8c-0.2-0.1-0.3-0.3-0.2-0.5s0.3-0.3,0.5-0.2 c1,0.7,2.3,0.9,3.5,0.5c0.8-0.3,1.4-0.9,1.8-1.6c0.1-0.2,0.3-0.3,0.5-0.2s0.3,0.3,0.2,0.5l0,0l0,0c-0.4,0.9-1.2,1.7-2.2,2.1 C54,41.4,53.6,41.5,53.1,41.5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18104",
    className: "st0",
    d: "M67.4,70.1c0,0,9.6,26.7,16.2,23.6c2.9-1.4,16.5-22.5,17-23c0.9-0.9,2.3-0.8,3.2-1.7 c0.4-0.5,0.8-1.1,1.1-1.7c0.5-0.9,0.9-2.1,0.2-2.9c-0.1-0.1-0.3-0.3-0.3-0.5s0.2-0.3,0.4-0.4l1.2-0.7c0.3-0.2,0.6-0.4,0.5-0.7 s-0.5-0.3-0.9-0.3c-3.3,0.7-7.1,2.8-9.9,4.5c0.2-0.9,0.3-1.8,0.3-2.6c0-0.7-0.1-1.6-0.8-1.7s-1.1,0.6-1.4,1.2 c-1.3,3.2-2.1,5.6-4.2,8.4s-4.3,5.6-6.4,8.4c-1.1-0.2-6.9-14.2-6.9-14.2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18105",
    className: "st2",
    d: "M82.5,94.4c-0.5,0-1-0.1-1.4-0.3C74.7,91.4,67.3,71.2,67,70.3c-0.1-0.2,0-0.4,0.2-0.5 s0.4,0,0.5,0.2s7.5,20.8,13.7,23.3c0.7,0.3,1.4,0.3,2.1,0c2.1-1,11-14.2,14.8-19.9c1.6-2.4,2-2.9,2.1-3c0.5-0.4,1.1-0.7,1.7-0.9 c0.5-0.1,1-0.4,1.4-0.8c0.4-0.5,0.7-1,1-1.6c0.6-1.2,0.7-2,0.3-2.4l-0.1-0.1c-0.4-0.3-0.4-0.8-0.1-1.2c0.1-0.1,0.2-0.2,0.3-0.3 l1.2-0.7c0.2-0.1,0.3-0.2,0.3-0.3c-0.1,0-0.3,0-0.4,0c-3.2,0.6-6.9,2.7-9.8,4.4c-0.1,0.1-0.3,0.1-0.4,0s-0.2-0.2-0.2-0.4 c0.2-0.8,0.3-1.7,0.3-2.6c0-0.4-0.1-1.2-0.5-1.3s-0.9,0.7-1,1c-0.2,0.5-0.4,1-0.6,1.5c-0.9,2.5-2.1,4.8-3.6,7 c-2.1,2.8-4.3,5.7-6.4,8.4c-0.1,0.1-0.2,0.2-0.4,0.1c-1.1-0.2-5-9.1-7.2-14.4c-0.1-0.2,0-0.4,0.2-0.5l0,0l0,0 c0.2-0.1,0.4,0,0.5,0.2l0,0l0,0c2.5,6.1,5.5,12.5,6.5,13.8c2.1-2.7,4.1-5.4,6.2-8.1c1.5-2.1,2.7-4.4,3.5-6.8l0.6-1.5 c0.5-1.1,1.1-1.6,1.8-1.5c0.9,0.2,1.2,1.2,1.1,2.1c0,0.6-0.1,1.2-0.2,1.9c2.8-1.7,6.3-3.5,9.3-4.1c0.7-0.1,1.2,0.1,1.3,0.6 c0.1,0.2,0.1,0.7-0.7,1.1l-1.2,0.7c-0.1,0-0.1,0.1-0.2,0.1l0.1,0.1l0.1,0.1c1,1.1,0.1,2.8-0.1,3.3c-0.3,0.6-0.7,1.2-1.1,1.8 c-0.5,0.5-1.1,0.8-1.7,0.9c-0.5,0.1-1,0.4-1.5,0.8c-0.1,0.1-1,1.4-2,2.9c-6.6,9.9-13,19.2-15.1,20.1 C83.5,94.3,83,94.4,82.5,94.4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18106",
    className: "st2",
    d: "M32.5,93.7L32.5,93.7c-0.2,0-0.4-0.2-0.4-0.4L33.7,58c0-0.2,0.2-0.4,0.4-0.4 s0.4,0.2,0.4,0.4l-1.6,35.4C32.9,93.6,32.7,93.7,32.5,93.7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18107",
    className: "st2",
    d: "M65.6,65.2c-0.2,0-0.3-0.1-0.4-0.2l-2.9-6.8c-0.1-0.2,0-0.4,0.2-0.5s0.4,0,0.5,0.2l0,0 l2.9,6.8C66,64.9,65.9,65.1,65.6,65.2L65.6,65.2C65.7,65.2,65.6,65.2,65.6,65.2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18108",
    className: "st2",
    d: "M35.7,173.4c0,0-6.4-3.5-9.1,0c-1.7,2.4-2.7,5.1-2.9,8c0,0,13.4,2.2,13.5,0 S35.7,173.4,35.7,173.4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18109",
    className: "st0",
    d: "M101.7,51.9h89.8c2.6,0,4.7,2.1,4.7,4.7v22.2c0,2.6-2.1,4.7-4.7,4.7h-89.8 c-2.6,0-4.7-2.1-4.7-4.7V56.6C97,54,99.1,51.9,101.7,51.9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18110",
    className: "st2",
    d: "M191.5,84h-89.8c-2.8,0-5.1-2.3-5.1-5.1l0,0V56.6c0-2.8,2.3-5.1,5.1-5.1h89.8 c2.8,0,5.1,2.3,5.1,5.1v22.2C196.6,81.6,194.4,84,191.5,84L191.5,84 M101.7,52.3c-2.4,0-4.3,2-4.4,4.4v22.2c0,2.4,2,4.4,4.4,4.4 h89.8c2.4,0,4.3-2,4.4-4.4V56.6c0-2.4-2-4.3-4.4-4.4L101.7,52.3z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    x: 105,
    y: 59.7,
    className: "st4",
    width: 14.3,
    height: 16.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18111",
    className: "st3",
    d: "M130.3,61.6H177c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-46.6 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C128.2,62.6,129.2,61.6,130.3,61.6L130.3,61.6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18112",
    className: "st3",
    d: "M130.3,69.7h31.5c1.2,0,2.1,0.9,2.1,2.1l0,0l0,0c0,1.2-0.9,2.1-2.1,2.1l0,0h-31.5 c-1.2,0-2.1-0.9-2.1-2.1l0,0l0,0C128.2,70.6,129.2,69.7,130.3,69.7L130.3,69.7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18113",
    className: "st0",
    d: "M2.8,117l54.3-14.7c1.8-0.5,3.6,0.6,4,2.3l0,0l6.6,24.3c0.5,1.8-0.6,3.6-2.3,4l0,0 l-54.3,14.7c-1.8,0.5-3.6-0.6-4-2.3l0,0L0.5,121C0,119.3,1.1,117.5,2.8,117"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18114",
    className: "st2",
    d: "M10.2,148.1c-1.7,0-3.1-1.1-3.5-2.7l-6.5-24.3c-0.5-2,0.6-4,2.6-4.5L57,102 c2-0.5,4,0.6,4.5,2.6l6.5,24.3c0.5,2-0.6,4-2.6,4.5L11.2,148C10.9,148.1,10.6,148.1,10.2,148.1 M58,102.6c-0.3,0-0.5,0-0.8,0.1 L2.9,117.4c-1.5,0.4-2.5,2-2,3.5l0,0l6.5,24.3c0.2,0.7,0.7,1.4,1.3,1.8c0.7,0.4,1.5,0.5,2.2,0.3l54.3-14.7 c0.7-0.2,1.4-0.7,1.8-1.4s0.5-1.5,0.3-2.2l-6.5-24.3C60.4,103.5,59.3,102.6,58,102.6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3765",
    x: 11.5,
    y: 121.8,
    transform: "matrix(0.9655 -0.2605 0.2605 0.9655 -33.1804 9.3401)",
    className: "st3",
    width: 14.3,
    height: 16.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18115",
    className: "st3",
    d: "M29.9,119.3l23.5-6.3c1.1-0.3,2.2,0.4,2.5,1.4v0.1c0.3,1.1-0.4,2.2-1.4,2.5L31,123.4 c-1.1,0.3-2.2-0.4-2.5-1.4v-0.1C28.2,120.7,28.8,119.6,29.9,119.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18116",
    className: "st3",
    d: "M31.8,127.1l18.4-5c1-0.3,2,0.3,2.2,1.3l0,0l0.1,0.5c0.3,1-0.3,2-1.3,2.2l0,0l-18.4,5 c-1,0.3-2-0.3-2.2-1.3l0,0l-0.1-0.5C30.2,128.4,30.8,127.4,31.8,127.1L31.8,127.1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18117",
    className: "st0",
    d: "M21,68.2c0,0-9.3,22.2-8.3,24.8s10.5,18.5,10.5,18.5s2.8,8.7,6.6,6.7 c2.5-1.3,1.2-8.8,1.2-8.8l2.8-0.8c0,0-4.6-1.9-5.1-2.8s-5.5-14.5-5.5-14.5l8.5-20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18118",
    className: "st2",
    d: "M28.7,118.9c-0.4,0-0.7-0.1-1-0.2c-2.8-1.1-4.6-6.4-4.8-7c-0.6-1.1-9.6-16-10.5-18.5 s7.4-22.8,8.3-25.1c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.1,0.3,0.3,0.2,0.5c-3.7,8.9-9,22.7-8.3,24.5c0.9,2.5,10.4,18.3,10.5,18.5v0.1 c0,0.1,1.8,5.6,4.3,6.6c0.6,0.2,1.2,0.2,1.7-0.1c1.8-1,1.3-6.4,1-8.4c0-0.2,0.1-0.4,0.3-0.4l1.7-0.5c-1.5-0.6-3.9-1.8-4.3-2.6 c-0.5-0.9-5.3-14-5.5-14.5c0-0.1,0-0.2,0-0.3l8.6-20.1c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.1,0.2,0.3,0.2,0.5l-8.4,19.9 c1.4,3.9,5,13.6,5.4,14.3c0.3,0.5,2.7,1.7,4.9,2.6c0.2,0.1,0.3,0.2,0.2,0.4c0,0.2-0.1,0.3-0.3,0.3l-2.5,0.7 c0.2,1.6,1,7.6-1.4,8.9C29.6,118.7,29.2,118.9,28.7,118.9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18119",
    className: "st2",
    d: "M74.6,170.6l-3.4,4.4l-11-2.2l-0.5,5.7c0,0,23.4,4.8,24.4,2.2S74.6,170.6,74.6,170.6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18120",
    className: "st2",
    d: "M118.8,8.2h-0.6V3h0.6v2.3h3V3h0.6v5.3h-0.6V5.8h-3V8.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18121",
    className: "st2",
    d: "M123.9,6.6c0,0.3,0.2,0.6,0.4,0.9c0.2,0.2,0.6,0.4,0.9,0.4c0.5,0,0.9-0.3,1.1-0.7l0.4,0.3 c-0.3,0.6-0.9,0.9-1.5,0.9c-0.5,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.8-0.5-1.3s0.2-0.9,0.5-1.3s0.8-0.6,1.2-0.6 c0.5,0,0.9,0.2,1.3,0.5c0.3,0.4,0.5,0.8,0.4,1.3c0,0.1,0,0.1,0,0.2L123.9,6.6z M126.3,6.2c0-0.6-0.5-1.1-1.1-1.1l0,0 c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.5-0.4,0.8C124,6.2,126.3,6.2,126.3,6.2z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3766",
    x: 127.7,
    y: 2.8,
    className: "st2",
    width: 0.5,
    height: 5.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18122",
    className: "st2",
    d: "M132.6,7.7c-0.3,0.4-0.7,0.6-1.2,0.6c-0.6,0-1.1-0.3-1.4-0.8V10h-0.5V4.6h0.5v0.8 c0.3-0.5,0.8-0.8,1.4-0.8c0.5,0,0.9,0.2,1.2,0.6C133.2,5.9,133.2,7,132.6,7.7 M132.2,7.4c0.2-0.3,0.4-0.6,0.3-1 c0-0.4-0.1-0.7-0.3-1S131.6,5,131.3,5c-0.4,0-0.7,0.1-0.9,0.4S130,6,130,6.4s0.1,0.7,0.4,1c0.2,0.3,0.6,0.4,0.9,0.4 C131.6,7.8,131.9,7.7,132.2,7.4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18123",
    className: "st2",
    d: "M136,3h1.6c0.7,0,1.5,0.2,2,0.8c0.5,0.5,0.8,1.2,0.8,1.9s-0.3,1.4-0.8,1.9s-1.2,0.8-2,0.7 H136V3z M136.6,7.7h1c0.6,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.6-0.6h-1V7.7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18124",
    className: "st2",
    d: "M141.6,7.8c-0.3-0.3-0.5-0.8-0.5-1.3c0-1,0.8-1.8,1.8-1.9h0.1c1,0,1.8,0.8,1.8,1.8l0,0 c0,1-0.8,1.9-1.9,1.9C142.4,8.3,141.9,8.1,141.6,7.8 M143.8,7.4c0.2-0.3,0.4-0.6,0.4-1s-0.1-0.7-0.4-1c-0.5-0.5-1.3-0.6-1.8-0.1 c0,0,0,0-0.1,0.1c-0.2,0.3-0.4,0.6-0.4,1s0.1,0.7,0.4,1c0.2,0.3,0.6,0.4,1,0.4C143.3,7.8,143.6,7.7,143.8,7.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18125",
    className: "st2",
    d: "M146.3,7.4c0.2,0.3,0.6,0.4,0.9,0.4c0.5,0,1-0.3,1.1-0.8l0.5,0.2c-0.2,0.7-0.9,1.1-1.6,1.1 c-0.5,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.8-0.5-1.3c0-1,0.8-1.8,1.8-1.9l0,0c0.7,0,1.3,0.4,1.6,1.1l-0.5,0.2 c-0.2-0.5-0.6-0.8-1.1-0.8c-0.4,0-0.7,0.1-0.9,0.4s-0.4,0.6-0.4,1C145.9,6.8,146.1,7.1,146.3,7.4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18126",
    className: "st2",
    d: "M150.2,4.6v2.1c-0.1,0.5,0.3,1,0.8,1.1c0.1,0,0.1,0,0.2,0c0.3,0,0.6-0.1,0.8-0.3 c0.2-0.2,0.3-0.5,0.3-0.8V4.6h0.5v3.6h-0.5V7.6C152,8,151.6,8.3,151,8.3c-0.7,0-1.3-0.5-1.4-1.2c0-0.1,0-0.1,0-0.2V4.6H150.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18127",
    className: "st2",
    d: "M156.4,8.2V6.1c0-0.6-0.3-1.1-0.9-1.1c-0.3,0-0.6,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v2 H154V4.6h0.5v0.6c0.2-0.4,0.7-0.7,1.2-0.7s1,0.3,1.1,0.7c0.3-0.4,0.7-0.7,1.3-0.7c0.7,0,1.3,0.5,1.3,1.2c0,0.1,0,0.1,0,0.2v2.2 h-0.5v-2c0-0.6-0.3-1.1-0.9-1.1c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v2.1C157,8.2,156.4,8.2,156.4,8.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18128",
    className: "st2",
    d: "M160.8,6.6c0,0.3,0.2,0.6,0.4,0.9c0.2,0.2,0.6,0.4,0.9,0.4c0.5,0,0.9-0.3,1.1-0.7l0.4,0.3 c-0.3,0.6-0.9,0.9-1.5,0.9c-0.5,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.8-0.5-1.3s0.2-0.9,0.5-1.3s0.8-0.6,1.2-0.6 c0.5,0,0.9,0.2,1.3,0.5c0.3,0.4,0.5,0.8,0.4,1.3c0,0.1,0,0.1,0,0.2L160.8,6.6z M163.2,6.2c0-0.6-0.5-1.1-1.1-1.1l0,0 c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.5-0.4,0.8C160.9,6.2,163.2,6.2,163.2,6.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18129",
    className: "st2",
    d: "M167.2,8.2V6.1c0.1-0.5-0.3-1-0.8-1.1c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0.1-0.8,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8v2h-0.5V4.6h0.5v0.7c0.2-0.5,0.7-0.7,1.2-0.7c0.7,0,1.3,0.5,1.4,1.2c0,0.1,0,0.1,0,0.2v2.2H167.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18130",
    className: "st2",
    d: "M169.1,7.3V5.1h-0.7V4.6h0.7v-1h0.5v1h0.9v0.5h-0.9v2.2c0,0.3,0.2,0.5,0.6,0.5 c0.1,0,0.2,0,0.3,0v0.4c-0.1,0-0.3,0.1-0.4,0.1C169.4,8.3,169.1,7.9,169.1,7.3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18131",
    className: "st2",
    d: "M173.4,8c-0.3,0.2-0.6,0.3-0.9,0.3c-0.6,0-1.2-0.3-1.4-0.9l0.4-0.2c0.1,0.4,0.5,0.7,1,0.7 c0.4,0,0.8-0.2,0.8-0.6c0-0.3-0.2-0.5-0.9-0.6c-0.4,0-0.7-0.2-0.9-0.4c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.3,0.1-0.6,0.4-0.8 c0.2-0.2,0.6-0.3,0.9-0.3c0.6,0,1.1,0.3,1.3,0.8l-0.4,0.2c-0.1-0.4-0.5-0.6-0.8-0.6c-0.2,0-0.4,0.1-0.5,0.2S172,5.5,172,5.7 c0,0.3,0.2,0.4,0.8,0.6c0.3,0.1,0.7,0.2,0.9,0.4c0.2,0.2,0.3,0.4,0.3,0.6C173.8,7.5,173.6,7.8,173.4,8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDocNew);
export default __webpack_public_path__ + "static/media/help_doc_new.7d98dd4e9f66f4ea0124dffcab90913f.svg";
export { ForwardRef as ReactComponent };